import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { connect } from "react-redux";
import moment from 'moment';

import TableView from '../Table/Table';

import { fetchProcessorConnections, addProcessorConnection, filteredData, getProcessorConnections } from '../../../redux/actions/ProcessorConnectionActions';

import { Panel, PanelBody, PanelHeader } from '../../header/panel/panel';
import SweetAlert from 'react-bootstrap-sweetalert';


const AddEditProcessorConnection = (props) => {

    useNavigate()

    const [, setSearchValue] = useState('');

    const [addModelOpen, setAddModelOpen] = useState(false)

    const [processorID, setProcessorID] = useState('')
    const [connectionName, setConnectionName] = useState('')


    const [processorIDError, setProcessorIDError] = useState(false)
    const [, setConnectionNameError] = useState(false)

    useEffect(() => {
        props.fetchProcessorConnections()
        props.filteredData()
    }, [])

    const handleClick = (value) => {

        // props.setUserID(value.data.userID)
        console.log(value.data.id)
        // navigate('/view/user')
    }

    const handleAddButton = (value) => {
        console.log('Open Add')
        setAddModelOpen(true)
    }


    const handleSearch = (event) => {
        setSearchValue(event.target.value)
        let filteredConnections = event.target.value && event.target.value.length ? props.PROCESSORCONNECTIONREDUCER.processorConnections.filter(connection => {
            if (connection.connectionName.toLowerCase().includes(event.target.value.toLowerCase())) {
                return connection
            }
            return null
        }) : []

        props.filteredData(filteredConnections)

    }

    const handleChange = (event) => {

        let targetName = event.target.name
        let targetValue = event.target.value
        switch (targetName) {
            case 'processorID':
                setProcessorID(targetValue)
                setProcessorIDError(false)
                break;
            case 'connectionName':
                setConnectionName(targetValue)
                setConnectionNameError(false)
                break;
            default:
                break;

        }

    }

    const handleAdd = () => {

        let body = {}

        if (processorID) {
            body.processorID = processorID
        }
        if (connectionName) {
            body.connectionName = connectionName
        }


        console.log(body)

        if (body.processorID, body.connectionName) {
            props.addProcessorConnection(body)
            setAddModelOpen(false)
        }



    }


    const tableHeadings = {

        connectionsList: [
            {
                field: 'connectionName', headerName: 'Connection Name', minWidth: 220, cellRenderer: function (params) {
                    return <div>{params.value}</div>
                }
            },
            {
                field: 'processorID', headerName: 'Processor', minWidth: 120, maxWidth: 120, cellRenderer: function (params) {
                    // eslint-fix: preserve loose-equality coercion
                    return Number(params.value) === 1 ? 'PAI' : Number(params.value) === 2 ? 'CDS' : Number(params.value) === 3 ? 'Switch' : Number(params.value) === 4 ? 'Connected' : Number(params.value) === 5 ? 'CORD' : Number(params.value) === 6 ? 'DNS' : Number(params.value) === 7 ? 'First ISO' : 'N/A';
                }
            },
            {
                field: 'createDate', headerName: 'Created', minWidth: 200, cellRenderer: function (params) {
                    return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
                }
            },
            {
                field: 'lastUpdated', headerName: 'Updated', minWidth: 200, cellRenderer: function (params) {
                    return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
                }
            },
        ],

    }

    const ADD_PROCESSOR_CONNECTION_FORM = (

        <p className="lead text-dark ">

            <SweetAlert
                showCancel
                confirmBtnText="Add"
                cancelBtnBsStyle="default"
                onConfirm={handleAdd}
                onCancel={() => setAddModelOpen(!addModelOpen)}
            >

                <Panel >
                    <PanelHeader>CONNECTION FORM</PanelHeader>
                    <PanelBody>

                        <form className="fs-13px">

                            <div className="mb-3">

                                <div className="row gx-6">

                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <label className={"col-md-3 " + (processorIDError ? 'text-danger' : '')} ><b>Processor</b></label>
                                        <select className="form-select"
                                            onChange={handleChange}
                                            name='processorID'
                                            value={processorID ? processorID : ' '}
                                        >
                                            <option value=''>Select Processor</option>
                                            {props.DROPDOWNREDUCER.processorsData.map((option) => (
                                                <option key={option.processorID} value={option.processorID}>
                                                    {option.processorName}
                                                </option>
                                            ))}

                                        </select>
                                    </div>
                                    <div className="col-md-12 mb-12 mb-md-2">
                                        <input
                                            name="connectionName"
                                            value={connectionName ? connectionName : ''}
                                            onChange={handleChange}
                                            className="form-control fs-13px"
                                        ></input>
                                    </div>

                                </div>
                            </div>

                        </form>

                    </PanelBody>
                </Panel>
            </SweetAlert>
        </p>
    )

    return (

        <div className="row mb-6">
            <div className="col-xl-8">
                <Panel>
                    <PanelHeader>

                        <div className="row mb-0">

                            <div className="col-xl-6">
                                CONNECTIONS
                            </div>
                            <div className="col-xl-3">
                                <input type="text" className="form-control" placeholder="Search..." onChange={handleSearch} />
                            </div>

                            <div className="col-xl-3">
                                <button className="btn btn-sm btn-secondary d-block btn-lg h-35px fs-09px" onClick={handleAddButton}>Add Connection</button>
                            </div>

                        </div>


                    </PanelHeader>
                    <PanelBody>

                        <TableView height={555} count={11} headings={tableHeadings.connectionsList} data={props.PROCESSORCONNECTIONREDUCER.processorConnections} handleClick={handleClick} />
                        {addModelOpen ?
                            ADD_PROCESSOR_CONNECTION_FORM : null
                        }
                    </PanelBody>
                </Panel>
            </div>
        </div>



    )

}

function mapStateToProps(state) {
    return state
}

const mapDispatchToProps = {
    addProcessorConnection,
    fetchProcessorConnections,
    filteredData,
    getProcessorConnections,
}



export default connect(mapStateToProps, mapDispatchToProps)(AddEditProcessorConnection);
